import { render, staticRenderFns } from "./ContentArea.vue?vue&type=template&id=bfc3057e&"
import script from "./ContentArea.vue?vue&type=script&lang=ts&"
export * from "./ContentArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports